import { jsx as _jsx } from "react/jsx-runtime";
import { Icon } from '@abb/uikit';
import React from 'react';
function InfoIconBold(props) {
    const { size = 18 } = props;
    return /*#__PURE__*/ _jsx(Icon, {
        className: "ibaicon",
        width: size,
        height: size,
        viewBox: "0 0 18 18",
        fill: props.fill ?? 'currentColor',
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ _jsx("path", {
            d: "M8.99996 17.3333C4.39746 17.3333 0.666626 13.6025 0.666626 8.99999C0.666626 4.39749 4.39746 0.666656 8.99996 0.666656C13.6025 0.666656 17.3333 4.39749 17.3333 8.99999C17.3333 13.6025 13.6025 17.3333 8.99996 17.3333ZM8.16663 8.16666V13.1667H9.83329V8.16666H8.16663ZM8.16663 4.83332V6.49999H9.83329V4.83332H8.16663Z",
            fill: props.fill ?? 'currentColor'
        })
    });
}
export default InfoIconBold;
